import React from "react";
import { Link } from "react-router-dom";
import { formatINR } from "@/lib/api";

const swatch = (c) => String(c || "").trim().toLowerCase().replace(/\s+/g, "");

export default function FabricCard({ fabric }) {
  const [hover, setHover] = React.useState(false);
  const img1 = fabric.images?.[0];
  const img2 = fabric.images?.[1] || img1;
  return (
    <Link
      to={`/fabric/${fabric.id}`}
      data-testid={`fabric-card-${fabric.id}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="group block"
    >
      <div className="relative aspect-square overflow-hidden bg-[#F5F5F5]">
        <img src={img1} alt={fabric.name} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-200 ${hover ? "opacity-0" : "opacity-100"}`} />
        <img src={img2} alt={`${fabric.name} alt`} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-200 ${hover ? "opacity-100" : "opacity-0"}`} />
        {fabric.best_seller && (
          <span className="absolute top-3 left-3 bg-black text-white text-[10px] uppercase tracking-[0.2em] px-2 py-1">Best Seller</span>
        )}
      </div>
      <div className="mt-4 flex items-start justify-between gap-2">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#4B5563]">{fabric.fabric_type || "Fabric"}</div>
          <div className="font-display text-lg mt-1 leading-tight">{fabric.name}</div>
        </div>
        <div className="text-right whitespace-nowrap">
          <div className="font-semibold">{formatINR(fabric.price_per_meter)} <span className="text-[11px] font-normal text-[#4B5563]">/ mtr</span></div>
        </div>
      </div>
      {fabric.colors?.length > 0 && (
        <div className="flex items-center gap-1.5 mt-2" data-testid={`fabric-card-colors-${fabric.id}`}>
          {fabric.colors.slice(0, 5).map((c) => (
            <span key={c} title={c} className="w-3.5 h-3.5 rounded-full border border-black/20" style={{ background: swatch(c) }} />
          ))}
        </div>
      )}
    </Link>
  );
}
